/*
 * Dreamy — socle du mouvement (DECISIONS D70-D72). Une respiration lente, jamais un effet.
 *
 * - UN SEUL IntersectionObserver partagé par tout le thème (rootMargin '0px 0px -12% 0px', seuils tous les 10 %).
 * - Dreamy.motion.observe(el, callback, { once = true }) : callback(entry, { initial, unobserve }).
 *   `initial` = première notification (élément déjà à l'écran au chargement → l'afficher sans animation).
 * - Dreamy.motion.register(init) : init(conteneur) est appelé sur le document, puis sur chaque section rechargée
 *   dans l'éditeur (shopify:section:load). Les éléments d'une section retirée sont oubliés (shopify:section:unload).
 * - La classe html.dr-motion signale que les animations sont permises : jamais en prefers-reduced-motion
 *   (suivi en direct), jamais dans l'éditeur de thème. Elle est posée tôt par layout/theme.liquid pour éviter tout
 *   clignotement, puis tenue à jour ici. Toutes les règles « avant animation » de dreamy-motion.css en dépendent :
 *   sans JavaScript, en mode éditeur ou en reduced-motion, tout le contenu reste visible.
 */
(function () {
  var D = (window.Dreamy = window.Dreamy || {});
  var root = document.documentElement;
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var THRESHOLDS = [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1];
  var records = new Map();
  var inits = [];
  var listeners = [];
  var io = null;

  function reduced() {
    return !!(mq && mq.matches);
  }
  function designMode() {
    return !!(window.Shopify && window.Shopify.designMode) || root.classList.contains('shopify-design-mode');
  }
  function enabled() {
    return !reduced() && !designMode();
  }
  function sync() {
    root.classList.toggle('dr-motion', enabled());
  }

  function unobserve(el) {
    if (io && records.has(el)) io.unobserve(el);
    records.delete(el);
  }

  function onEntries(entries) {
    for (var i = 0; i < entries.length; i++) {
      var entry = entries[i];
      var rec = records.get(entry.target);
      if (!rec) continue;
      var initial = !rec.notified;
      rec.notified = true;
      try {
        rec.callback(entry, { initial: initial, unobserve: unobserve.bind(null, entry.target) });
      } catch (e) {
        /* une animation ne doit jamais casser la page */
      }
      if (rec.once && entry.isIntersecting) unobserve(entry.target);
    }
  }

  function observe(el, callback, options) {
    if (!el || typeof callback !== 'function') return;
    if (!('IntersectionObserver' in window)) {
      // Navigateur ancien : on considère l'élément visible tout de suite.
      callback({ target: el, isIntersecting: true, intersectionRatio: 1 }, { initial: true, unobserve: function () {} });
      return;
    }
    if (!io) io = new IntersectionObserver(onEntries, { rootMargin: '0px 0px -12% 0px', threshold: THRESHOLDS });
    records.set(el, { callback: callback, once: !options || options.once !== false, notified: false });
    io.observe(el);
  }

  function register(init) {
    if (typeof init !== 'function') return;
    inits.push(init);
    try {
      init(document);
    } catch (e) {}
  }

  function refresh(container) {
    sync();
    for (var i = 0; i < inits.length; i++) {
      try {
        inits[i](container || document);
      } catch (e) {}
    }
  }

  function onChange(fn) {
    if (typeof fn === 'function') listeners.push(fn);
  }

  function changed() {
    sync();
    var on = enabled();
    for (var i = 0; i < listeners.length; i++) {
      try {
        listeners[i](on);
      } catch (e) {}
    }
    document.dispatchEvent(new CustomEvent('dreamy:motion-change', { detail: { enabled: on, reduced: reduced() } }));
  }

  if (mq) {
    if (mq.addEventListener) mq.addEventListener('change', changed);
    else if (mq.addListener) mq.addListener(changed);
  }

  document.addEventListener('shopify:section:load', function (e) {
    refresh(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    records.forEach(function (_, el) {
      if (e.target.contains(el)) unobserve(el);
    });
  });

  /* ---------- 1, 2, 5 : apparitions au scroll ([data-reveal], [data-reveal-group]) ---------- */
  var batch = new Map();
  var batchQueued = false;
  function cascadeIndex(el) {
    var g = el.closest('[data-reveal-group]');
    if (!g) return 0;
    var n = batch.get(g) || 0;
    batch.set(g, n + 1);
    if (!batchQueued) {
      batchQueued = true;
      requestAnimationFrame(function () {
        batch.clear();
        batchQueued = false;
      });
    }
    return Math.min(n, 5); // au-delà du 6e, même délai que le 6e
  }
  function ms(token) {
    return parseFloat(getComputedStyle(root).getPropertyValue(token)) || 0;
  }
  function reveal(el) {
    var i = cascadeIndex(el);
    el.style.setProperty('--i', i);
    el.classList.add('is-revealing');
    el.classList.remove('is-pending');
    var total = ms(el.getAttribute('data-reveal') === 'media' ? '--d-xl' : '--d-l') + i * 120 + 260;
    setTimeout(function () {
      el.classList.remove('is-revealing');
      el.style.removeProperty('--i');
    }, total);
  }
  function showAll() {
    var pending = document.querySelectorAll('.is-pending');
    for (var i = 0; i < pending.length; i++) {
      unobserve(pending[i]);
      pending[i].classList.remove('is-pending');
    }
  }
  // Accessibilité (recette prompt 5) : un bloc qui reçoit le focus clavier s'affiche aussitôt, sans attendre l'animation.
  document.addEventListener('focusin', function (e) {
    var el = e.target.closest && e.target.closest('.is-pending, .is-revealing');
    if (!el) return;
    unobserve(el);
    el.classList.remove('is-pending', 'is-revealing');
    el.style.removeProperty('--i');
  });
  function initReveal(scope) {
    if (!enabled()) return;
    // Le premier écran n'est jamais animé : aucune apparition dans la première section de la page.
    var first = document.querySelector('#MainContent > .shopify-section');
    var els = (scope.querySelectorAll ? scope : document).querySelectorAll('[data-reveal]');
    var vh = window.innerHeight;
    for (var k = 0; k < els.length; k++) {
      var el = els[k];
      if (el.__drReveal || (first && first.contains(el))) continue;
      el.__drReveal = true;
      var r = el.getBoundingClientRect();
      if (r.top < vh) continue; // déjà à l'écran (ou au-dessus) : affiché sans animation
      el.classList.add('is-pending');
      observe(el, function (entry) {
        if (entry.isIntersecting) reveal(entry.target);
      });
    }
  }

  /* ---------- 4 : frise « Vos 7 premières nuits » ---------- */
  var timelines = [];
  var tlQueued = false;
  function drawTimeline(tl) {
    var r = tl.el.getBoundingClientRect();
    var V = window.innerHeight;
    var H = r.height || 1;
    // Même plage que animation-range: entry 20% cover 60%.
    var start = V - 0.2 * Math.min(H, V);
    var end = V - 0.6 * (V + H);
    var p = Math.max(0, Math.min(1, (start - r.top) / (start - end)));
    tl.el.style.setProperty('--progress', p.toFixed(3));
    var drawn = p * H;
    for (var i = 0; i < tl.items.length; i++) tl.items[i].classList.toggle('is-reached', tl.items[i].offsetTop + 8 <= drawn);
  }
  function onScroll() {
    if (tlQueued) return;
    tlQueued = true;
    requestAnimationFrame(function () {
      tlQueued = false;
      for (var i = 0; i < timelines.length; i++) if (timelines[i].active) drawTimeline(timelines[i]);
    });
  }
  function initTimelines(scope) {
    if (!enabled()) return;
    var els = (scope.querySelectorAll ? scope : document).querySelectorAll('.dr-timeline');
    for (var k = 0; k < els.length; k++) {
      if (els[k].__drTl) continue;
      var tl = { el: els[k], items: Array.prototype.slice.call(els[k].children), active: false };
      els[k].__drTl = tl;
      timelines.push(tl);
      observe(
        els[k],
        function (entry) {
          var t = entry.target.__drTl;
          t.active = entry.isIntersecting || entry.boundingClientRect.top < window.innerHeight;
          drawTimeline(t);
        },
        { once: false }
      );
      drawTimeline(tl);
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  /* ---------- Prompt 3 : glisser (tiroirs, test de sommeil) ---------- */
  // swipe(zone, { dir: 1 (vers la droite) | -1, width(), move(d, f), end(close), when() }).
  // Tactile et stylet uniquement. Le geste ne démarre que si le mouvement est d'abord horizontal (angle < 30°) et dans
  // le sens de fermeture ; sinon le navigateur garde le défilement vertical (touch-action: pan-y dans dreamy-motion.css).
  // Fermeture : déplacement > 30 % de la largeur OU vitesse > 0,5 px/ms. Jamais de dépassement au-delà de la position
  // de repos (pas de rebond parasite). Le clic qui suit un glisser est neutralisé (on ne choisit pas une réponse en glissant).
  function swipe(zone, o) {
    if (!zone || zone.__drSwipe || !window.PointerEvent) return;
    zone.__drSwipe = true;
    var s = null;
    var frame = 0;
    var mute = false;
    function reset() {
      s = null;
    }
    zone.addEventListener(
      'pointerdown',
      function (e) {
        s = e.pointerType !== 'mouse' && e.isPrimary && (!o.when || o.when()) ? { x: e.clientX, y: e.clientY, id: e.pointerId } : null;
      },
      { passive: true }
    );
    zone.addEventListener(
      'pointermove',
      function (e) {
        if (!s || e.pointerId !== s.id) return;
        var dx = e.clientX - s.x;
        var dy = e.clientY - s.y;
        if (!s.on) {
          if (Math.abs(dx) < 10 && Math.abs(dy) < 10) return;
          if (Math.abs(dy) > Math.abs(dx) * 0.577 || dx * o.dir <= 0) return reset();
          s.on = true;
          s.x = e.clientX;
          s.w = Math.max(1, o.width());
          s.v = -1;
          s.lx = e.clientX;
          s.lt = e.timeStamp;
          try {
            zone.setPointerCapture(e.pointerId);
          } catch (err) {}
          return;
        }
        var dt = e.timeStamp - s.lt;
        var inst = dt > 0 ? ((e.clientX - s.lx) * o.dir) / dt : 0;
        if (dt > 0) s.v = s.v < 0 ? inst : 0.6 * inst + 0.4 * s.v; // première mesure prise telle quelle (gestes courts)
        s.lx = e.clientX;
        s.lt = e.timeStamp;
        s.d = Math.max(0, dx * o.dir);
        if (!frame)
          frame = requestAnimationFrame(function () {
            frame = 0;
            if (s && s.on) o.move(s.d, Math.min(1, s.d / s.w));
          });
      },
      { passive: true }
    );
    function up(e) {
      if (!s || e.pointerId !== s.id) return;
      var g = s;
      reset();
      if (!g.on) return;
      if (frame) cancelAnimationFrame(frame);
      frame = 0;
      var fast = e.type === 'pointerup' && e.timeStamp - g.lt < 100 && g.v > 0.5;
      o.end(e.type === 'pointerup' && ((g.d || 0) > 0.3 * g.w || fast));
      mute = true;
      setTimeout(function () {
        mute = false;
      }, 350);
    }
    zone.addEventListener('pointerup', up);
    zone.addEventListener('pointercancel', up);
    zone.addEventListener(
      'click',
      function (e) {
        if (!mute) return;
        mute = false;
        e.preventDefault();
        e.stopPropagation();
      },
      true
    );
  }

  // Retour en place : ressort en var(--d-m), sans animation en reduced-motion.
  function settle(el, props) {
    el.style.transition = reduced() ? 'none' : 'transform var(--d-m) var(--ease-spring), opacity var(--d-m) var(--ease-out)';
    for (var k in props) el.style.setProperty(k, props[k]);
    setTimeout(function () {
      el.style.transition = '';
    }, 400);
  }
  function follow(el, x) {
    el.style.transition = 'none';
    el.style.transform = x ? 'translate3d(' + x + 'px,0,0)' : '';
  }

  function initSwipes() {
    // Tiroir panier (Dawn, à droite) : glisser vers la droite pour fermer. Le voile s'estompe avec le geste.
    // Écouteurs sur <cart-drawer> (stable) : Dawn remplace le contenu de #CartDrawer après chaque ajout au panier.
    var cart = document.querySelector('cart-drawer');
    if (cart) {
      var part = function (sel) {
        return cart.querySelector(sel);
      };
      swipe(cart, {
        dir: 1,
        when: function () {
          return cart.classList.contains('active') && !!part('.drawer__inner');
        },
        width: function () {
          return part('.drawer__inner').offsetWidth;
        },
        move: function (d, f) {
          follow(part('.drawer__inner'), d);
          var veil = part('.cart-drawer__overlay');
          if (veil) {
            veil.style.transition = 'none';
            veil.style.opacity = 1 - f;
          }
        },
        end: function (close) {
          var inner = part('.drawer__inner');
          var veil = part('.cart-drawer__overlay');
          if (close) {
            // La transition de fermeture de Dawn part de la position du doigt.
            inner.style.transition = inner.style.transform = '';
            if (veil) veil.style.transition = veil.style.opacity = '';
            cart.close();
          } else {
            settle(inner, { transform: '' });
            if (veil) settle(veil, { opacity: '' });
          }
        },
      });
    }

    // Tiroir menu (<dialog>, à gauche) : glisser vers la gauche pour fermer.
    var menu = document.getElementById('DreamyMenu') || document.querySelector('.dr-drawer');
    if (menu) {
      var fade = function (v) {
        if (v === '') menu.style.removeProperty('--drag-fade');
        else menu.style.setProperty('--drag-fade', v);
      };
      swipe(menu, {
        dir: -1,
        when: function () {
          return menu.open;
        },
        width: function () {
          return menu.offsetWidth;
        },
        move: function (d, f) {
          follow(menu, -d);
          fade(1 - f);
        },
        end: function (close) {
          if (!close) {
            settle(menu, { transform: '' });
            fade('');
            return;
          }
          // La fermeture animée de D.closeDialog (classe is-closing) part de la position du doigt.
          menu.style.transition = menu.style.transform = '';
          fade('');
          if (D.closeDialog) D.closeDialog(menu);
        },
      });
    }

    // Test de sommeil : glisser vers la droite sur une question = question précédente. Jamais de glisser pour avancer.
    var quizzes = document.querySelectorAll('dreamy-quiz');
    for (var i = 0; i < quizzes.length; i++) {
      (function (quiz) {
        var screen = function () {
          return quiz.querySelector('[data-quiz-screen="question"]:not([hidden])');
        };
        swipe(quiz, {
          dir: 1,
          when: function () {
            return typeof quiz.current === 'number' && !!screen();
          },
          width: function () {
            return quiz.offsetWidth;
          },
          move: function (d) {
            follow(screen(), d);
          },
          end: function (close) {
            var el = screen();
            if (!close) return settle(el, { transform: '' });
            follow(el, 0);
            el.style.transition = '';
            quiz.goBack();
          },
        });
      })(quizzes[i]);
    }
  }

  /* ---------- Prompt 4 : retours de clic ---------- */
  // Safari iOS n'applique :active (appui à .97) qu'en présence d'un écouteur tactile.
  document.addEventListener('touchstart', function () {}, { passive: true });

  function token(name) {
    return getComputedStyle(root).getPropertyValue(name).trim();
  }
  // play(el, images clés, durée, courbe, délai) : Web Animations ; rien en reduced-motion ni dans l'éditeur.
  function play(el, frames, dur, ease, delay) {
    if (!el || !el.animate || !enabled()) return null;
    return el.animate(frames, { duration: ms(dur), easing: token(ease) || 'ease', delay: delay || 0, fill: 'backwards' });
  }
  var UP = [{ opacity: 0, transform: 'translate3d(0,6px,0)' }, { opacity: 1, transform: 'none' }];
  // Fondu croisé vertical (prix, libellés) : l'ancien texte monte de 6 px et s'efface, le nouveau arrive d'en dessous.
  function swap(el, apply) {
    if (!el || !el.parentNode || !enabled()) return apply();
    var old = el.cloneNode(true);
    old.removeAttribute('id');
    old.removeAttribute('aria-live');
    old.setAttribute('aria-hidden', 'true');
    old.style.cssText += ';position:absolute;margin:0;pointer-events:none;top:' + el.offsetTop + 'px;left:' + el.offsetLeft + 'px;width:' + el.offsetWidth + 'px';
    el.parentNode.insertBefore(old, el.nextSibling);
    apply();
    play(el, UP, '--d-m', '--ease-out');
    var a = play(old, [{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translate3d(0,-6px,0)' }], '--d-m', '--ease-out');
    if (a) a.onfinish = a.oncancel = function () {
      old.remove();
    };
    else old.remove();
  }

  // Accordéons : hauteur fluide native (interpolate-size + ::details-content, dreamy-motion.css) ; sinon repli
  // Web Animations sur le contenu. Sans JS : ouverture native instantanée. Un second clic pendant l'animation est ignoré.
  var nativeAcc = !!(window.CSS && CSS.supports && CSS.supports('interpolate-size', 'allow-keywords'));
  document.addEventListener('click', function (e) {
    var sum = !nativeAcc && enabled() && e.target.closest && e.target.closest('.dr-acc > summary');
    var d = sum && sum.parentNode;
    var body = d && d.querySelector('.dr-acc__body');
    if (!body || !body.animate) return;
    e.preventDefault();
    if (d._a) return;
    var open = d.open;
    d.open = true;
    var cs = getComputedStyle(body);
    var full = { height: body.offsetHeight + 'px', paddingBottom: cs.paddingBottom, opacity: 1 };
    var none = { height: '0px', paddingBottom: '0px', opacity: 0 };
    body.style.overflow = 'hidden';
    var a = (d._a = body.animate(open ? [full, none] : [none, full], { duration: ms('--d-m'), easing: token('--ease-out') }));
    a.onfinish = a.oncancel = function () {
      d._a = null;
      body.style.overflow = '';
      if (open) d.open = false;
    };
  });

  onChange(function (on) {
    if (!on) showAll();
    else refresh(document);
  });

  sync();

  D.motion = {
    enabled: enabled,
    reduced: reduced,
    designMode: designMode,
    observe: observe,
    unobserve: unobserve,
    register: register,
    refresh: refresh,
    onChange: onChange,
    swipe: swipe,
    ms: ms,
    token: token,
    play: play,
    swap: swap,
  };

  register(initReveal);
  register(initTimelines);
  register(initSwipes);
})();
